import { render, staticRenderFns } from "./tarif-admission.html?vue&type=template&id=95a5517a&scoped=true&external"
import script from "./tarif-admission.js?vue&type=script&lang=js&external"
export * from "./tarif-admission.js?vue&type=script&lang=js&external"
import style0 from "./tarif-admission.scss?vue&type=style&index=0&id=95a5517a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a5517a",
  null
  
)

export default component.exports